import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";
import { PAGE_ACCESS_PUBLIC } from "%/dynamic-components/render-engine/helpers/page-access-mode";

// Who may view the page (task 223). The audience is server-only: PageAccess.vue reads and
// writes it through /studio/destination/{dest}/page/{dc}/audience, never into rootOptions.
export default class PageAccess extends BaseRootOption {
  static optionKey = "page-access";

  static userInterfaceComponent = {
    label: "Who can view",
    component: inspectorTools.PAGE_ACCESS,
    useVerticalOrientation: true,
    useDivider: true,
  };

  static defaultValue = { mode: PAGE_ACCESS_PUBLIC };
}
